import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Home.css';

const About = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="about-hero-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="section-title">About Us</h1>
            <p className="section-subtitle">
              Building Excellence, Creating Trust, Delivering Value
            </p>
          </motion.div>
        </div>
      </section>

      {/* Our Foundation Section */}
      <section className="foundation-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Our Foundation</h2>
            <p className="section-subtitle">
              Vibha Corporation & Co. is a partnership firm founded by Mr. & Mrs. Sundar Rajan Jagannathan, built on the pillars of integrity, expertise, and customer-centricity.
            </p>
          </motion.div>

          <motion.div
            className="foundation-content"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="foundation-text">
              With operations primarily in Chennai and select cities across Tamil Nadu, we have established ourselves as a trusted name in the construction and real estate industry. Our commitment to quality, transparency, and customer satisfaction has been the cornerstone of our success.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Our Legacy Section */}
      <section className="legacy-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Our Legacy</h2>
            <p className="section-subtitle">
              Our founder, SRJ, brings exceptional credentials to Vibha Corporation
            </p>
          </motion.div>

          <div className="horizontal-legacy-row">
            <motion.div
              className="legacy-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="legacy-card-header">
                <div className="legacy-icon">⏱️</div>
                <h3 className="legacy-card-title">20+ Years Experience</h3>
              </div>
              <div className="legacy-card-content">
                <p>Two decades of industry leadership experience in real estate and construction</p>
              </div>
            </motion.div>

            <motion.div
              className="legacy-card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="legacy-card-header">
                <div className="legacy-icon">🏢</div>
                <h3 className="legacy-card-title">Radiance Realty</h3>
              </div>
              <div className="legacy-card-content">
                <p>Former Chief Operating Officer at Radiance Realty Developers India Ltd.</p>
              </div>
            </motion.div>

            <motion.div
              className="legacy-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.6 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="legacy-card-header">
                <div className="legacy-icon">🌐</div>
                <h3 className="legacy-card-title">CBRE Leadership</h3>
              </div>
              <div className="legacy-card-content">
                <p>Former Head of Land Services at CB Richard Ellis (CBRE) Chennai</p>
              </div>
            </motion.div>

            <motion.div
              className="legacy-card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.8 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="legacy-card-header">
                <div className="legacy-icon">💰</div>
                <h3 className="legacy-card-title">₹5,500+ Crores</h3>
              </div>
              <div className="legacy-card-content">
                <p>Successfully managed transactions worth ₹5,500+ Crores across South India</p>
              </div>
            </motion.div>

            <motion.div
              className="legacy-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 1.0 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="legacy-card-header">
                <div className="legacy-icon">🏭</div>
                <h3 className="legacy-card-title">NDR Warehousing</h3>
              </div>
              <div className="legacy-card-content">
                <p>Current consultant for NDR Warehousing managing 16 Million Sq. Ft portfolio</p>
              </div>
            </motion.div>
          </div>

          {/* Horizontal Divider */}
          <motion.div
            className="about-divider"
            initial={{ opacity: 0, scaleX: 0 }}
            whileInView={{ opacity: 1, scaleX: 1 }}
            transition={{ duration: 0.8, delay: 1.2 }}
            viewport={{ once: true }}
          />
        </div>
      </section>

      {/* Vision & Mission Section */}
      <section className="vision-mission-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Our Vision & Mission</h2>
            <p className="section-subtitle">
              Guiding principles that drive our commitment to excellence
            </p>
          </motion.div>

          <div className="horizontal-vision-row">
            <motion.div
              className="vision-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="vision-card-header">
                <div className="vision-icon">👁️</div>
                <h3 className="vision-card-title">Our Vision</h3>
              </div>
              <div className="vision-card-content">
                <p>To be Tamil Nadu's most trusted construction and Real Estate Services Company, delivering exceptional value through innovative solutions and unwavering commitment to quality.</p>
              </div>
            </motion.div>

            <motion.div
              className="vision-card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
              viewport={{ once: true }}
              whileHover={{
                y: -8,
                boxShadow: 'var(--shadow-2xl)',
                transition: { duration: 0.3 }
              }}
            >
              <div className="vision-card-header">
                <div className="vision-icon">🎯</div>
                <h3 className="vision-card-title">Our Mission</h3>
              </div>
              <div className="vision-card-content">
                <p>To serve our customers with utmost care and responsibility, ensuring delight and satisfaction while achieving all stakeholder objectives through transparent, efficient, and sustainable construction practices.</p>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Our Commitment Section */}
      <section className="commitment-section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="section-title">Our Commitment</h2>
            <p className="section-subtitle">
              Building relationships, trust, and lasting value
            </p>
          </motion.div>

          <motion.div
            className="commitment-content"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <p className="commitment-quote">
              "At Vibha Corporation, we don't just build structures; we build relationships, trust, and lasting value. Every project is a testament to our commitment to excellence and our promise to deliver beyond expectations."
            </p>
            <p className="commitment-text">
              Ready to start your next project? Contact us today for a consultation.
            </p>
            <div className="commitment-buttons">
              <Link 
                to="/contact" 
                className="btn-primary-large"
                onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })}
              >
                Contact Us
              </Link>
              <Link 
                to="/projects" 
                className="btn-secondary"
                onClick={() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' })}
              >
                View Projects
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default About;
